import { render, staticRenderFns } from "./learningvideos.vue?vue&type=template&id=2665f13c&"
import script from "./learningvideos.vue?vue&type=script&lang=js&"
export * from "./learningvideos.vue?vue&type=script&lang=js&"
import style0 from "./learningvideos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports